import { business } from "../../business";

export const pageHeading = "Talk to Us";
export const headerImg = "./images/inner-header-bg.png";
export const list = [
  {
    icon: "./images/phone-icon.png",
    title: "Phone and WhatsApp",
    text: business.phone,
  },
  {
    icon: "./images/mail-icon.png",
    title: "Email",
    text: business.email,
  },
];
